"use strict";
module.exports = {
    entityModel: 'settlement',
    events: {
        SETTLEMENT_CREATED: 'SETTLEMENT_CREATED',
        SETTLEMENT_UPDATED: 'SETTLEMENT_UPDATED',
        SETTLEMENT_SENT_TO_SUPPLIER_ORGANIZATION: 'SETTLEMENT_SENT_TO_SUPPLIER_ORGANIZATION',
    },
    actions: {
        get: 'v1.settlement.get',
        list: 'v1.settlement.list',
        createForPeriod: 'v1.settlement.createForPeriod',
        sendToSupplierOrganization: 'v1.settlement.sendToSupplierOrganization',
        receiveInvoiceFromSupplierOrganization: 'v1.settlement.receiveInvoiceFromSupplierOrganization',
        markInvoiceAsDone: 'v1.settlement.markInvoiceAsDone',
        resendReport: 'v1.settlement.resendReport',
        setReceiver: 'v1.settlement.setReceiver',
        cancel: 'v1.settlement.cancel',
        addToReport: 'v1.settlement.addToReport',
        removeFromReport: 'v1.settlement.removeFromReport',
        sendToExternalFortnox: 'v1.settlement.sendToExternalFortnox',
        upsert: 'v1.settlement.upsert',
        upsertWhenEmpty: 'v1.settlement.upsertWhenEmpty',
        updateWhenEmpty: 'v1.settlement.updateWhenEmpty',
        update: 'v1.settlement.update',
    },
    settlementStates: {
        created: 'created',
        sentToSupplierOrganization: 'sentToSupplierOrganization',
        invoiceReceivedFromSupplierOrganization: 'invoiceReceivedFromSupplierOrganization',
        invoiceCompleted: 'invoiceCompleted',
    },
    serviceAgreements: {
        'v2.5': 'v2.5',
        v3: 'v3',
    },
    settlementRows: {
        sections: {
            sales: 'sales',
            systembolaget: 'systembolaget',
            adjustments: 'adjustments',
        },
    },
};
